<section class="flex items-center justify-center min-h-screen">
  <div
    class="flex flex-col py-10 px-10 3xl:px-14 4xl:px-18 items-center bg-white shadow-lg rounded-lg containerLogin"
  >
    <div class="w-full">
      <p class="text-[0.9em] 3xl:text-[1em] 4xl:text-[1.2em] text-black mb-4">
        Il tuo account è protetto con l'autenticazione a due fattori. <br />
        Abbiamo inviato un codice di verifica alla tua email.
      </p>
      <label for="code" class="block text-dimot-1 mb-2 text-[0.8em] 3xl:text-[0.9em] 4xl:text-[1em]"
        >Per completare l’accesso, inserisci il codice qui sotto:</label
      >
      <div class="w-full flex flex-col items-center justify-center">
        <input
          type="number"
          [(ngModel)]="mfaCode"
          id="code"
          class="h-12 3xl:h-13 4xl:h-14 text-[0.8em] 3xl:text-[0.95em] 4xl:text-[1.1em] p-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-gray-600 focus:border-gray-600 block w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
        <button
          class="w-full cursor-pointer h-12 3xl:h-13 4xl:h-14 bg-dimot-1 text-white text-[0.75em] 3xl:text-[0.9em] 4xl:text-[1.05em] p-3 rounded-lg mt-8 hover:bg-[#20329d] transition mx-auto block"
          (click)="onVerifyCode()"
        >
          ACCEDI
        </button>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger text-red-500 mt-3">
      {{ errorMessage }}
    </div>
  </div>
</section>
